(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  function setupCompactNavigation(root) {
    const menus = root.querySelectorAll('.pd-nav');
    menus.forEach(function (nav) {
      if (nav.dataset.pdHoverReady === 'true') return;
      nav.dataset.pdHoverReady = 'true';
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      const groups = Array.from(nav.querySelectorAll('.pd-nav__group'));
      function closeOthers(except) {
        groups.forEach(function (group) { if (group !== except) group.open = false; });
      }
      groups.forEach(function (group) {
        const summary = group.querySelector('summary');
        group.addEventListener('pointerenter', function (event) {
          if (!canHover.matches || event.pointerType !== 'mouse') return;
          closeOthers(group);
          group.open = true;
        });
        group.addEventListener('pointerleave', function (event) {
          if (!canHover.matches || event.pointerType !== 'mouse') return;
          if (!group.contains(document.activeElement)) group.open = false;
        });
        group.addEventListener('focusout', function (event) {
          if (!group.contains(event.relatedTarget)) group.open = false;
        });
        group.addEventListener('keydown', function (event) {
          if (event.key !== 'Escape') return;
          group.open = false;
          if (summary) summary.focus();
          event.stopPropagation();
        });
        if (summary) {
          summary.addEventListener('click', function (event) {
            if (canHover.matches && event.detail > 0 && group.open) event.preventDefault();
          });
        }
      });
      document.addEventListener('pointerdown', function (event) {
        if (!nav.contains(event.target)) closeOthers(null);
      });
    });
  }
  function init() { setupCompactNavigation(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) {
    setupCompactNavigation(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
